import { render, staticRenderFns } from "./OilImportTable.vue?vue&type=template&id=3a80d5e4&scoped=true"
import script from "./OilImportTable.vue?vue&type=script&lang=ts"
export * from "./OilImportTable.vue?vue&type=script&lang=ts"
import style0 from "./OilImportTable.vue?vue&type=style&index=0&id=3a80d5e4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a80d5e4",
  null
  
)

export default component.exports